export default "__VITE_ASSET__HCWvAh4c__"